import ApiService from "@/common/api.service";
import AuthService from "@/common/auth.service";
import {
  LOGIN,
  REGISTER,
  DATA_USER,
  GET_BALANCE,
  RECOVER_PASSWORD,
  RESTORE_PASSWORD,
  GENERATE_2FA_TOKEN,
  VERIFY_2FA_TOKEN
} from "../actions.type";

import { SET_AUTH, SET_BALANCE } from "../mutations.type";

const state = {
  user: AuthService.getUser()
};

const getters = {
  user(state) {
    return state.user;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return ApiService.post("auth/login", credentials).then(data => {
      context.commit(SET_AUTH, data.user);
      return Promise.resolve(data.user);
    });
  },

  [REGISTER](context, credentials) {
    return ApiService.post("auth/register", { user: credentials }).then(
      data => {
        context.commit(SET_AUTH, data.user);
        return Promise.resolve(data);
      }
    );
  },

  [GET_BALANCE](context) {
    return ApiService.get("auth/getBalance").then(data => {
      context.commit(SET_BALANCE, data.balance);
    });
  },

  [DATA_USER]() {
    return ApiService.get("auth/dataUser");
  },

  [RECOVER_PASSWORD](context, data) {
    return ApiService.post("auth/recover", data);
  },

  [RESTORE_PASSWORD](context, data) {
    return ApiService.post("auth/restore", data);
  },

  [GENERATE_2FA_TOKEN]() {
    return ApiService.get("auth/2fa/generate");
  },

  [VERIFY_2FA_TOKEN](context, data) {
    return ApiService.post("auth/2fa/verify", data);
  }
};

const mutations = {
  [SET_AUTH](state, user) {
    state.user = user;

    ApiService.setHeader();
    AuthService.saveToken(state.user.token);
    AuthService.saveUser(state.user);
  },

  [SET_BALANCE](state, balance) {
    state.user.balance = balance;
    AuthService.saveUser(state.user);
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
